import { useQuery } from '@tanstack/react-query'
import { incidentsService } from '../services/incidentsService'
import { useSelectedPropertyId } from '../../../store/propertyStore'
import type { Incident } from '../types/incident.types'

export const INCIDENTS_QUERY_KEY = 'incidents' as const

interface UseIncidentsOptions {
  refetchInterval?: number
}

export function useIncidents(options: UseIncidentsOptions = {}) {
  const propertyId = useSelectedPropertyId()
  return useQuery<Incident[]>({
    queryKey: [INCIDENTS_QUERY_KEY, { propertyId }],
    queryFn: () => incidentsService.list({ property_id: propertyId ?? undefined }),
    refetchInterval: options.refetchInterval,
    meta: { silent: true, source: 'useIncidents' },
  })
}
